import type { ActionTemplateSearchResource } from "@octopusdeploy/octopus-server-client";
import { ActionHandlerCategory } from "@octopusdeploy/octopus-server-client";
import type * as React from "react";
import ActionTemplateCardList from "~/components/ActionTemplates/ActionTemplateCardList";
import Section from "~/components/Section";
import TransitionAnimation from "~/components/TransitionAnimation/TransitionAnimation";
import styles from "./InstalledActionTemplateList.module.less";
interface RenderTemplateGroupProps {
    templates: ActionTemplateSearchResource[];
    sectionHeader: string;
    renderSingleTemplate: (template: ActionTemplateSearchResource) => React.ReactElement;
}
function renderTemplateGroup({ templates, sectionHeader, renderSingleTemplate }: RenderTemplateGroupProps): React.ReactElement {
    return templates.length > 0 ? (<>
            <Section sectionHeader={sectionHeader} className={styles.stepTemplatesHeader}/>
            <ActionTemplateCardList>{templates.map((template) => renderSingleTemplate(template))}</ActionTemplateCardList>
        </>) : (<Section sectionHeader={sectionHeader} className={styles.stepTemplatesHeader} bodyClassName={styles.stepTemplatesNoResult}>
            No results found
        </Section>);
}
interface RenderCategoryTemplatesProps {
    categoryTemplates: ActionTemplateSearchResource[];
    activeCategory?: ActionHandlerCategory;
    sectionHeader: string;
    renderSingleTemplate: (template: ActionTemplateSearchResource) => React.ReactElement;
}
export function renderCategoryTemplates({ categoryTemplates, activeCategory, sectionHeader, renderSingleTemplate }: RenderCategoryTemplatesProps): React.ReactElement | null {
    if (categoryTemplates.length === 0) {
        return null;
    }
    return (<TransitionAnimation key={activeCategory}>
            {activeCategory !== ActionHandlerCategory.Featured ? <Section sectionHeader={sectionHeader} className={styles.stepTemplatesHeader}/> : <></>}
            <ActionTemplateCardList>{categoryTemplates.map((template) => renderSingleTemplate(template))}</ActionTemplateCardList>
        </TransitionAnimation>);
}
interface RenderFilteredTemplatesProps {
    filteredResults: ActionTemplateSearchResource[];
    sectionHeader: string;
    renderSingleTemplate: (template: ActionTemplateSearchResource) => React.ReactElement;
    transitionKey: string;
}
export function renderFilteredTemplates({ filteredResults, sectionHeader, renderSingleTemplate, transitionKey }: RenderFilteredTemplatesProps): React.ReactElement {
    return <TransitionAnimation key={transitionKey}>{renderTemplateGroup({ templates: filteredResults, sectionHeader, renderSingleTemplate })}</TransitionAnimation>;
}
